import { render, staticRenderFns } from "./fei.vue?vue&type=template&id=226badd9&scoped=true"
import script from "./fei.vue?vue&type=script&lang=js"
export * from "./fei.vue?vue&type=script&lang=js"
import style0 from "./fei.vue?vue&type=style&index=0&id=226badd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226badd9",
  null
  
)

export default component.exports